import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Invoice from "../../../containers/modules/purchasing/invoice";

export default function InvoiceRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="invoice"
      index
      element={
        <AccessControl
          name={"Invoice List"}
          auth={authUser}
          component={() => <Invoice />}
        />
      }
    />
  );
}
